console.log("👀 Cart Observer activo");

(function () {

  let lastCartHash = "";

  async function getCartHash() {
  try {

    const res = await fetch('/cart.js');

    if (!res.ok) {
      console.warn("⚠️ Cart no listo aún...");
      return null;
    }

    const cart = await res.json();

    return JSON.stringify(
      cart.items.map(item => ({
        id: item.id,
        qty: item.quantity
      }))
    );

  } catch (e) {
    console.warn("⚠️ Error temporal cart (ignorado)");
    return null;
  }
}

  async function checkCartChange() {
    const newHash = await getCartHash();

    if (!newHash) return;

    if (lastCartHash && lastCartHash !== newHash) {
      console.log("🔄 Cambio REAL detectado en carrito");

      if (window.Shipping) {
        // 🔥 esperar a que Shipping esté listo
const waitForShipping = setInterval(() => {

  if (window.Shipping && window.Shipping.applyShippingLogic) {

    console.log("✅ Shipping listo → ejecutando");

    window.Shipping.applyShippingLogic();

    clearInterval(waitForShipping);
  }

}, 100);
      }
    }

    lastCartHash = newHash;
  }

  // 🔁 loop ligero
  setInterval(checkCartChange, 400);

})();
